
const pcmConsentForm = () => {
  return (
    <div className="mb-3 p-4">
      <p className="mb-2 font-medium">
        I consent to participate in Principal Care Management (PCM) program provided by Sunil Gupta,
        M.D., LLC d/b/a Retina Specialty Institute for the management of my serious eye disease.
      </p>
      <p className="mb-2 font-bold">
        Condition Being Managed
      </p>
      <p className="mb-2 font-medium">
        I understand that I have one or more serious chronic ophthalmic conditions, such as (but not
        limited to) diabetic retinopathy, retinal vein occlusion, neovascular macular degeneration,
        uveitis-related macular disease, or other sight-threatening retinal disease, which are expected to
        last at least three (3) months and such conditions place me at risk for vision loss, functional
        decline, or complications requiring urgent care or surgery.
      </p>
      <p className="mb-2 font-bold">
        Purpose of PCM in My Eye Care
      </p>
      <p className="mb-2 font-medium">
        PCM services are designed to improve coordination and outcomes for my retinal/ophthalmic
        condition through proactive management between visits.
      </p>
      <p className="mb-2 font-bold">
        PCM Services May Include:
      </p>

      <ul className="list-disc font-medium list-inside mb-2 text-black ">
        <li className="font-medium text-black ">
          Development and ongoing updates of a retina-specific care plan.
        </li>
        <li className="font-medium text-black ">
          Monitoring of disease status (e.g., imaging review such as OCT, fluorescein angiography,
          fundus photography).
        </li>
        <li className="font-bold text-black ">
          Coordination of care with:
        </li>
        <ul className="list-disc font-medium list-inside mb-2 text-black px-5">
          <li className="font-medium text-black ">
            Primary care physicians.
          </li>
          <li className="font-medium text-black ">
            Endocrinology (e.g., diabetes management).
          </li>
          <li className="font-medium text-black ">
            Other eye care providers or specialists
          </li>
        </ul>
        <li className="font-medium text-black ">
          Review and interpretation of diagnostic testing related to my eye condition.
        </li>
        <li className="font-medium text-black ">
          Medication management, including ocular injections, drops, and systemic medications
          impacting eye disease.
        </li>
        <li className="font-medium text-black ">
          Patient education regarding disease progression, treatment options, and injection
          schedules.
        </li>
        <li className="font-medium text-black ">
          Communication with me between visits via phone, portal messages, or other electronic
          means.
        </li>
        <li className="font-medium text-black ">
          Care coordination for procedures such as intravitreal injections, laser treatment, or
          surgery referral.
        </li>
      </ul>
      <p className="mb-2 text-black  font-bold">
        Billing and Program Requirements:
      </p>
      <ul className="list-disc font-medium list-inside mb-2 text-black">
        <li className="font-medium text-black ">
          PCM services will be billed when at least 30 minutes of clinical time per calendar month
          is spent managing my condition(s).
        </li>
        <li className="font-medium text-black ">
          Only one physician or qualified practitioner will bill PCM services for me per month for
          the same condition.
        </li>
      </ul>
      <p className="mb-2 font-bold">
        Cost and Insurance:
      </p>
      <ul className="list-disc font-medium list-inside mb-2 text-black">
        <li className="font-medium text-black ">
          These services are covered by Medicare and many other healthcare payors; however, I
          acknowledge that I may be responsible for deductibles and coinsurance depending on my
          insurance plan.
        </li>
        <li className="font-medium text-black ">
          I acknowledge that I have had the opportunity to request information from the practice
          regarding potential out-of-pocket costs.
        </li>
      </ul>
      <p className="mb-2 font-bold">
        Voluntary Participation:
      </p>
      <ul className="list-disc font-medium list-inside mb-2 text-black">
        <li className="font-medium text-black ">
          I acknowledge that enrollment and my participation in the PCM program is voluntary.
        </li>
        <li className="font-medium text-black ">
          I acknowledge that I have been informed that I may discontinue participation in the PCM
          program at any time by notifying the practice without affecting my access to medically
          necessary eye care.
        </li>
        <li className="font-medium text-black ">
          I acknowledge and agree that my discontinuation in the PCM program will not be
          effective for actions already taken by my healthcare provider or that are in progress and
          will only be prospectively effective.
        </li>
      </ul>
      <p className="mb-2 font-bold">
        Communication & Care Coordination:
      </p>
      <ul className="list-disc font-medium list-inside mb-2 text-black">
        <li className="font-medium text-black ">
          I hereby authorize communication related to my eye condition through telephone calls,
          secure messaging, and care coordination between visits.
        </li>
        <li className="font-medium text-black ">
          I understand that my health information may be shared with other treating providers as
          needed to support my vision care and overall health.
        </li>
      </ul>
    </div>
  );
};

export default pcmConsentForm;
